module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_1.8520ce7e.jpg";